export const toggleSelectAll = <T extends { isSelected: boolean }>(lines: T[], disabledF?: (val: T) => boolean): T[] => {
	if (lines.filter(t => t.isSelected).length > 0) {
		return lines.map(t => ({ ...t, isSelected: false }));
	} else if (disabledF) {
		return lines.map(t => ({ ...t, isSelected: disabledF(t) ? false : true }));
	} else {
		return lines.map(t => ({ ...t, isSelected: true }));
	}
};
